import type { LoginCredentials } from "./auth.types";
import type { AuthSession } from "./models/session.model";
import type { Tenant } from "../tenant/types";
import { resolveAuthFromEmail } from "../identity/services/identity-auth.resolver";
import { SEED_TENANTS } from "../tenant/data/seed";

export function createDemoTenant(overrides?: Partial<Tenant>): Tenant {
  const base =
    SEED_TENANTS.find((t: Tenant) => t.id === overrides?.id) ?? SEED_TENANTS[0];
  return { ...base, ...overrides };
}

export function mapCredentialsToSession(
  credentials: LoginCredentials
): AuthSession {
  const resolved = resolveAuthFromEmail(credentials.email);

  if (!resolved) {
    throw new Error("Identifiants invalides");
  }

  return {
    user: resolved.user,
    tenant: resolved.tenant,
    membership: resolved.membership,
    tokens: { accessToken: "", refreshToken: "", expiresAt: 0 },
  };
}

export function mapSessionWithTokens(
  partial: Omit<AuthSession, "tokens"> & { tokens?: AuthSession["tokens"] },
  tokens: AuthSession["tokens"]
): AuthSession {
  return { ...partial, tokens };
}
